import {gql} from "@apollo/client";
import {ConsultWithCCMInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthConsultWithCCM($input: ConsultWithCCMInput) {
    submitAuthConsultWithCCM(input: $input) {
        guid
    }
}`;

type AuthConsultWithCCMInput = ConsultWithCCMInput & {
    authorizationGuid: string;
}

export function useAuthConsultWithCCM(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthConsultWithCCMInput }, void>(GRAPHQL_MUTATION);
    const submitConsultWithCCM = useCallback(async function (formValues: ConsultWithCCMInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'Clinical Consult request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitConsultWithCCM
    }
}
